import React from "react";

const LockerComponentSVG = ({ width, height }) => {
  return (
    <svg
      width={width}
      fontSize="2px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsxslink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M225.832,30.167H94.557c-4.645,0-8.41,3.765-8.41,8.41v402.265c0,4.646,3.765,8.411,8.41,8.411h131.275
			c4.645,0,8.41-3.765,8.41-8.41V38.577C234.242,33.933,230.476,30.167,225.832,30.167z M217.422,432.432H102.967V46.987h114.455
			V432.432z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M177.643,83.172h-34.898c-4.645,0-8.41,3.765-8.41,8.41c0,4.645,3.765,8.41,8.41,8.41h34.898
			c4.645,0,8.41-3.765,8.41-8.41C186.053,86.937,182.288,83.172,177.643,83.172z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M177.643,113.965h-34.898c-4.645,0-8.41,3.765-8.41,8.41c0,4.645,3.765,8.41,8.41,8.41h34.898
			c4.645,0,8.41-3.765,8.41-8.41C186.053,117.73,182.288,113.965,177.643,113.965z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M177.643,144.756h-34.898c-4.645,0-8.41,3.765-8.41,8.41c0,4.645,3.765,8.41,8.41,8.41h34.898
			c4.645,0,8.41-3.765,8.41-8.41C186.053,148.522,182.288,144.756,177.643,144.756z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M447.609,0H256H64.39c-4.645,0-8.41,3.765-8.41,8.41v462.601c0,4.645,3.765,8.41,8.41,8.41h14.857v24.169
			c0,4.645,3.765,8.41,8.41,8.41h39.898c4.645,0,8.41-3.765,8.41-8.41v-24.169h48.461v24.169c0,4.645,3.765,8.41,8.41,8.41h39.898
			c4.645,0,8.41-3.765,8.41-8.41v-24.169H256h14.857v24.169c0,4.645,3.765,8.41,8.41,8.41h39.898c4.645,0,8.41-3.765,8.41-8.41
			v-24.169h48.461v24.169c0,4.645,3.765,8.41,8.41,8.41h39.898c4.645,0,8.41-3.765,8.41-8.41v-24.169h14.857
			c4.645,0,8.41-3.765,8.41-8.41V8.41C456.019,3.765,452.254,0,447.609,0z M119.145,495.18H96.066v-15.759h23.078V495.18z
			 M224.323,495.18h-23.078v-15.759h23.078V495.18z M247.59,462.601H72.8V16.82h174.79V462.601z M310.754,495.18h-23.078v-15.759
			h23.078V495.18z M415.933,495.18h-23.078v-15.759h23.078V495.18z M439.199,462.601H264.41V16.82h174.789V462.601z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M417.442,30.167H286.167c-4.645,0-8.41,3.765-8.41,8.41v402.265c0,4.646,3.765,8.411,8.41,8.411h131.275
			c4.645,0,8.41-3.765,8.41-8.41V38.577C425.852,33.933,422.086,30.167,417.442,30.167z M409.032,432.432H294.577V46.987h114.455
			V432.432z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M369.254,83.172h-34.898c-4.645,0-8.41,3.765-8.41,8.41c0,4.645,3.764,8.41,8.41,8.41h34.898
			c4.645,0,8.41-3.765,8.41-8.41C377.664,86.937,373.898,83.172,369.254,83.172z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M369.254,113.965h-34.898c-4.645,0-8.41,3.765-8.41,8.41c0,4.645,3.764,8.41,8.41,8.41h34.898
			c4.645,0,8.41-3.765,8.41-8.41C377.664,117.73,373.898,113.965,369.254,113.965z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M369.254,144.756h-34.898c-4.645,0-8.41,3.765-8.41,8.41c0,4.645,3.765,8.41,8.41,8.41h34.898
			c4.645,0,8.41-3.765,8.41-8.41C377.664,148.522,373.898,144.756,369.254,144.756z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M191.743,225.496c-4.645,0-8.41,3.765-8.41,8.41v45.249c0,4.645,3.765,8.41,8.41,8.41c4.645,0,8.41-3.765,8.41-8.41
			v-45.249C200.153,229.261,196.388,225.496,191.743,225.496z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M385.409,225.496c-4.645,0-8.41,3.765-8.41,8.41v45.249c0,4.645,3.765,8.41,8.41,8.41c4.645,0,8.41-3.765,8.41-8.41
			v-45.249C393.819,229.261,390.053,225.496,385.409,225.496z"
          />
        </g>
      </g>
    </svg>
  );
};

export default LockerComponentSVG;
